// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__9ffVD","description":"style_description__P8j7h","actions":"style_actions__wvkiN","actions_btn":"style_actions_btn__U7TRB"};